// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  OK: 'OK',
  CLOSE: 'Close',
  SET: 'Set',
  SAVE: 'Save',
  ACCEPT_ALL: 'Accept All',
  SELECT: 'Select',
  EDIT: 'Edit',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  REQUIRED: 'Required',
  RESEARCH_ERROR:
    'We are sorry, but the ride is no longer available for requested pick-up date and time. Please try to search for a ride again.',
}

export default createMessages<typeof MESSAGES>('UIKIT_COMMONS', MESSAGES)
